import Contactraw from "./customization/Contact.json";

export function Path(props) {
    return (
		<p class="path"> 
			<span>&nbsp;<i class="fa-brands fa-apple">&nbsp;&nbsp;</i></span>
			<span>&nbsp;&nbsp;<i class="fa fa-folder-open">&nbsp;</i>{props.path}&nbsp;&nbsp;</span>
		</p>
    );
}

export function Code(props) {
    return (
        <p id="code">
            &nbsp;&gt; {props.command} <br/>
        </p>
    );
}



export function ASCII() {
    return (
        <pre style={{ textAlign: 'center', alignItems: 'center'}}>
            <h2>
                <code>
                    {`
                    
██████╗  █████╗ ███████╗██╗     ██╗██╗ █████╗ ██████╗ ███████╗
██╔══██╗██╔══██╗██╔════╝██║     ██║██║██╔══██╗██╔══██╗╚══███╔╝
██████╔╝███████║█████╗  ██║     ██║██║███████║██████╔╝  ███╔╝ 
██╔══██╗██╔══██║██╔══╝  ██║     ██║██║██╔══██║██╔══██╗ ███╔╝  
██║  ██║██║  ██║██║     ███████╗██║██║██║  ██║██║  ██║███████╗
╚═╝  ╚═╝╚═╝  ╚═╝╚═╝     ╚══════╝╚═╝╚═╝╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝
                                                              
`}
                </code>
            </h2>
        </pre>
    );
}


export function Contact() {
    return (
        <div class="contact">
            <p><i class="fa-solid fa-envelope"></i> Email: <a href={Contactraw.email} target="_blank"  rel="noreferrer">[Rafli.arraafi@gmail.com]</a></p>
            <p><i class="fa-brands fa-whatsapp"></i> Whatsapp: <a href={Contactraw.whatsapp} target="_blank"  rel="noreferrer">+6295339555312</a></p>
            <p><i class="fa-brands fa-instagram"></i> Instagram: <a href={Contactraw.instagram} target="_blank"  rel="noreferrer">@rafliiarz</a></p>
        </div>
    );
}
